'use strict';

exports.__esModule = true;
exports['default'] = getAlert;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function getAlert(type, message) {
  return _react2['default'].createElement(
    'div',
    { className: 'ui message ' + type },
    message
  );
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/tcomb-form-templates-semantic/lib/getAlert.js
// module id = 316
// module chunks = 0